import { useTranslation } from 'react-i18next';

interface DisclaimerProps {
  className?: string;
  theme?: 'light' | 'dark';
}

export default function Disclaimer({ className = '', theme = 'light' }: DisclaimerProps) {
  const { t } = useTranslation('legal');
  return (
    <div className={`text-xs text-center py-4 px-4 ${className}`}>
      <p className={`${theme === 'dark' ? 'text-slate-400' : 'text-gray-500'}`}>
        {t('disclaimerFull')}
      </p>
    </div>
  );
}

